import { Pipe, PipeTransform } from '@angular/core';
import {DateUtils} from '@shared/utils/date-utils.class';

@Pipe({
  name: 'startOfMonth'
})
export class StartOfMonthPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if (value)
      return DateUtils.convertYYYYMMtoStartDate(String(value));
    return value;
  }


}
